import React from "react";
import ReactMarkdown from "react-markdown";

export default ({
  data: {
    contentfulStran: {
      tekst: { tekst }
    }
  }
}) => {
  return (
    <div>
      <ReactMarkdown source={tekst} />
    </div>
  );
};

export const query = graphql`
  query KlubPageQuery {
    contentfulStran(naslov: { eq: "Klub" }) {
      id
      naslov
      tekst {
        tekst
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/klub/index.js